import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Suspense } from 'react'

import { useRecentMarkets } from '@/state/recentMarkets'

import RecentMarketPanel from './marketPanel'
import RecentMarketsSkeleton from './skeleton'

interface Props {
    clientCode: string
}

export default function RecentMarkets({ clientCode }: Props) {
    const markets = useRecentMarkets(clientCode)

    if (!markets || !markets.length) {
        return null
    }

    return (
        <div className="mb-12">
            <div className="flex justify-between">
                <h2 className="mb-2 text-xl">Recent Markets</h2>
                <Link
                    to="/$client_code/markets"
                    params={{ client_code: clientCode }}
                    className="flex items-center hover:text-primary"
                >
                    View all
                    <ArrowRight className="w-3 h-3 ml-2" />
                </Link>
            </div>
            <Suspense fallback={<RecentMarketsSkeleton />}>
                <div className="grid grid-cols-4 gap-4 mt-4">
                    {markets.map(marketCode => (
                        <RecentMarketPanel key={marketCode} clientCode={clientCode} marketCode={marketCode} />
                    ))}
                </div>
            </Suspense>
        </div>
    )
}
